<template>
  <div class="vc-date-range d-flex">
    <v-menu
      v-model="isMenuOpen"
      v-bind="menuProps"
      :close-on-content-click="false"
      content-class="date-range-menu-content"
      :offset-y="true"
    >
      <template v-slot:activator="{ on, attrs }">
        <VcitaTextField
          :class="{'v-input--is-focused': isMenuOpen && (!value[0])}"
          :disabled="disabled"
          class="date-picker-text-start"
          ref="textInput"
          v-bind="{...attrs}"
          :label="$t('booking.info.start_date')"
          :value="computedFirstDateFormatted"
          prepend-inner-icon="icon-Calendar"
          color="rgba(0, 0, 0, 0.4)"
          autocomplete="off"
          readonly
          clear-icon="far fa-times-circle"
          v-on="on"
        >

        </VcitaTextField>
        <VcitaTextField
          :class="{'v-input--is-focused': value[0] && !value[1]}"
          :disabled="disabled"
          class="date-picker-text-end"
          ref="textInput"
          v-bind="{...attrs}"
          :label="$t('booking.info.end_date')"
          :value="computedSecondDateFormatted"
          prepend-inner-icon=""
          color="rgba(0, 0, 0, 0.4)"
          autocomplete="off"
          readonly
          clear-icon="far fa-times-circle"
          v-on="on"
        >

        </VcitaTextField>
      </template>
      <v-date-picker
        :show-current="false"
        range
        ref="datePicker"
        no-title
        class="date-picker-comp"
        v-bind="$attrs"
        color="var(--brand-color-secondary)"
        width="292px"
        v-model="computedValue"
        v-on="$listeners"
        @click.native="onClick"
      >
      </v-date-picker>

    </v-menu>
  </div>
</template>

<script>
import VcitaTextField from "@/modules/common/components/VcitaTextField/VcitaTextField.vue"
import moment from "moment";

export default {
  name: 'VcDateRange',
  components: {
    VcitaTextField,
  },
  data() {
    return {
      isMenuOpen: false,
      isRangeSet: false,
      currentHover: null,
      allNodes: [],
      focusMonth: null,
    }
  },
  props: {
    menuProps: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Array,
      default: ['',''],
    },
    disabled: {
      type: Boolean,
      default: false
    },
    closeAfterSelection: {
      type: Boolean,
      default: false
    },
    displayFormat: {
      type: String,
      default: 'DD MMM YYYY'
    }
  },
  watch: {
    currentHover: function(val) {
      if (this.value.length !== 2) this.resetHover();
      if (this.value.length == 1) {
        var fixedDate = this.value[0];
        var valueDate = this.getFloatingDate(fixedDate, val);
        for (var i = 1; i <= this.allNodes.length; i++) {
          var iDate = this.getFloatingDate(fixedDate, i);
          if (fixedDate > valueDate && iDate >= valueDate && fixedDate >= iDate) {
            if (iDate === fixedDate) {
              this.addEndSelection(i-1)
              continue;
            }
            else if (iDate === valueDate){
              this.addStartSelection(i-1)
              continue;
            }
            this.addClass(i-1);
          }
          else if (fixedDate < valueDate && iDate <= valueDate && fixedDate <= iDate) {
            if (iDate === fixedDate) {
              this.addStartSelection(i-1)
              continue;
            }
            else if (iDate === valueDate){
              this.addEndSelection(i-1)
              continue;
            }
            this.addClass(i-1)
          }
        }
      }
    },
    value: function(val) {
      if (!this.value[0] && !this.value[1]) {
        this.resetHover()
        return
      }
      var self = this;
      self.allNodes = document.querySelectorAll(".v-date-picker-table td .v-btn");

      var observer = new MutationObserver(function(mutations){
        for (var i=0; i < mutations.length; i++){
          if (i == mutations.length -1) {
            var headerText = document.querySelector(".v-date-picker-header__value button");
            if (headerText) {
              headerText = headerText.innerText;
              self.focusMonth = new Date(headerText).toLocaleDateString().split('/').reverse().join('-').substring(0,8);
            }
            self.initDateHoverEvent();
          }
        }
      });
      observer.observe(document.getElementsByClassName("v-picker__body")[0], {
        childList: true,
        subtree: true,
      });

      if (val.length === 1) {
        self.initDateHoverEvent();
      }
    },
  },
  computed: {
    computedFirstDateFormatted() {
      if (!this.value[0]) return ''
      return moment(this.value[0])
        .format(this.displayFormat);
    },
    computedSecondDateFormatted() {
      if (!this.value[1]) return ''
      return moment(this.value[1])
        .format(this.displayFormat);
    },
    computedValue: {
      get: function() {
        return this.value.map((date)=> {return date ? moment(date).format('YYYY-MM-DD') : ''})
      },
      set: function(val){
        if (this.closeAfterSelection && val[0] && val[1]) this.isMenuOpen = false
        val.sort()
      }
    }
  },
  methods: {
    onClick: function() {
      if (this.isRangeSet && !this.value[1]){
        this.resetHover()
        this.isRangeSet = false
      }
      else if (this.value[0] && this.value[1]) {
        this.isRangeSet = true
      }
    },
    addClass: function(i) {
      this.allNodes[i].parentNode.classList.add("highlight__date");
      this.allNodes[i].classList.add("highlight__date__btn");
    },
    addStartSelection: function(i){
      this.allNodes[i].parentNode.classList.add("highlight__start");
      this.allNodes[i].classList.add("edge__start");
    },
    addEndSelection: function(i){
      this.allNodes[i].parentNode.classList.add("highlight__end");
      this.allNodes[i].classList.add("edge__end");
    },
    resetHover: function() {
      for (var i = 0; i < this.allNodes.length; i++) {
        this.allNodes[i].parentNode.classList.remove("highlight__date");
        this.allNodes[i].classList.remove("highlight__date__btn");
        this.allNodes[i].parentNode.classList.remove("highlight__start");
        this.allNodes[i].parentNode.classList.remove("highlight__end");
        this.allNodes[i].classList.remove("edge__start");
        this.allNodes[i].classList.remove("edge__end");
      }
    },
    initDateHoverEvent: function () {
      var self = this;
      self.allNodes = document.querySelectorAll(".v-date-picker-table td .v-btn");
      self.allNodes.forEach(function(node) {
        node.addEventListener("mouseover", function() {
          self.currentHover = node.innerText;
        });
      });
    },
    getFloatingDate(fixedDate, val) {
      var valueDate = val.toString().length == 1 ? "0" + val : val;
      var joinDate = this.focusMonth ? this.focusMonth : fixedDate.substring(0, 8);
      return joinDate + valueDate;
    }
  }
}
</script>

<style lang="scss" scoped>
  //$my-color: mix(#00dcf7, #fff, 20%);

  .vc-date-range {
    ::v-deep{
      //INPUTS
       .vcita-text-input.v-text-field.v-input--is-focused{
        .v-input__slot{
          border: 1px solid var(--brand-color-secondary);
          box-sizing: border-box;
          box-shadow: 0px 0px 0px 3px rgba(var(--brand-color-secondary-rgb), 0.36);
          z-index: 2;
        }
      }
       .vcita-text-input.v-text-field:not(.v-input--is-focused):hover {
        .v-input__slot{
          border-color: rgba(0, 0, 0, 0.3);
        }
      }


        .vcita-text-input.v-text-field.date-picker-text-start .v-input__slot{
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          .v-icon{
            font-size: 20px;
          }
        }
        .vcita-text-input.v-text-field.date-picker-text-end .v-input__slot{
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }

    }
  }
  .date-range-menu-content ::v-deep {
    min-width: unset !important;

    .v-date-picker-table{
      height: auto;
      table{border-spacing: 0 10px}
      td.highlight__date{
        background-color: rgba(var(--brand-color-secondary-rgb) ,0.2);
        .v-btn{
          background-color: unset!important;
          color: rgba(0, 0, 0, 0.87);
          &::before{background-color: unset}
        }
        //USED TO HANDLE ROUNDED ELEMENTS ON THE EDGE - DISABLED FOR NOW
        //&:first-of-type{
        //  background: unset;
        //  background: linear-gradient(to right, transparent 50%, rgba(var(--brand-color-secondary-rgb) ,0.2) 50%);
        //  .v-btn{background-color:$my-color!important;}
        //}
        //&:last-of-type{
        //  background: unset;
        //  background: linear-gradient(to right, rgba(var(--brand-color-secondary-rgb) ,0.2) 50%, transparent 50%);
        //  .v-btn{background-color: $my-color!important;}
        //}

      }
      td.highlight__start {
        background: linear-gradient(to right, transparent 50%, rgba(var(--brand-color-secondary-rgb) ,0.2) 50%);
      }
      td.highlight__end {
        background: linear-gradient(to right, rgba(var(--brand-color-secondary-rgb) ,0.2) 50%, transparent 50%);
      }
      td.highlight__end, td.highlight__start{
        .v-btn{
          background-color: var(--brand-color-secondary);
          color: #FFFFFF;
        }
      }

      .v-btn{
        &.v-date-picker-table__current:not(.v-btn--active) {
          color: rgba(0, 0, 0, 0.87) !important;
          border: 2px solid var(--brand-color-secondary);
        }
        &:hover{
          background: rgba(0, 0, 0, 0.07);
          &::before{background-color: unset}
        }
      }
    }
  }

</style>
